import { motion } from "framer-motion";
import { fadeUp, stagger } from "../animations";

const SkillCard = ({ title, desc, skills }) => (
  <motion.div
    variants={fadeUp}
    whileHover={{ y: -6 }}
    className="bg-[#0b1020] p-6 rounded-xl border border-white/10"
  >
    <h3 className="font-semibold mb-2">{title}</h3>
    <p className="text-gray-400 text-sm mb-3">{desc}</p>
    <div className="flex flex-wrap gap-2">
      {skills.map((s) => (
        <span
          key={s}
          className="text-xs px-3 py-1 border border-white/10 rounded-full text-gray-400"
        >
          {s}
        </span>
      ))}
    </div>
  </motion.div>
);

export default function Skills() {
  return (
    <motion.section
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={stagger}
      className="max-w-6xl mx-auto px-6 py-16"
    >
      <h2 className="text-2xl font-semibold mb-8 text-yellow-300">
        Core Skills
      </h2>

      <div className="grid md:grid-cols-2 gap-6">
        <SkillCard
          title="Full Stack & Backend"
          desc="Scalable APIs and web applications"
          skills={[
            "Python",
            "Flask",
            "FastAPI",
            "PHP",
            "CodeIgniter",
            "REST APIs",
            "MySQL",
          ]}
        />

        <SkillCard
          title="AI & Machine Learning"
          desc="ML pipelines with deployment"
          skills={[
            "OCR",
            "NLP",
            "Spam Detection",
            "Classification",
            "Model Deployment",
          ]}
        />

        <SkillCard
          title="Mobile & Frontend"
          desc="Modern UI and mobile experiences"
          skills={[
            "Flutter",
            "Dart",
            "HTML",
            "CSS",
            "JavaScript",
            "Responsive UI",
          ]}
        />

        <SkillCard
          title="Tools & Platforms"
          desc="Development & hosting tools"
          skills={[
            "Git",
            "GitHub",
            "Postman",
            "Linux",
            "cPanel",
            "WordPress",
          ]}
        />
      </div>
    </motion.section>
  );
}
